import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import {
  GetSubscribersParams,
  SubscribersResponse,
  ServiceType,
  SubscriberStatus,
  OperationType,
  AvailableOffersResponse,
  GetAvailableOffersParams,
} from '../models/subscriber.model';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class SubscriberService {
  private readonly API_URL = '/subscribers';
  private apiService = inject(ApiService);


  private buildQueryParams(params: Record<string, any>): string {
    const queryParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            queryParams.append(key, item.toString());
          });
        } else {
          queryParams.append(key, value.toString());
        }
      }
    });

    return queryParams.toString();
  }

  getSubscribers(params: GetSubscribersParams): Observable<SubscribersResponse> {
    const queryString = this.buildQueryParams({
      pageNumber: params.pageNumber,
      pageSize: params.pageSize,
      serviceType: params.serviceType,
      status: params.status,
      operationType: params.operationType,
    });

    const url = `${this.API_URL}?${queryString}`;

    const options = {
      headers: {
        'X-QueryString': params.queryString,
      },
    };

    return this.apiService.get<SubscribersResponse>(url, options);
  }

  getSubscribersByCpf(
    cpf: string,
    pageNumber: number = 1,
    pageSize: number = 10,
    options?: {
      serviceType?: ServiceType | ServiceType[];
      status?: SubscriberStatus | SubscriberStatus[];
      operationType?: OperationType;
    }
  ): Observable<SubscribersResponse> {
    return this.getSubscribers({
      queryString: `cpf=${cpf}`,
      pageNumber,
      pageSize,
      ...options,
    });
  }

  getSubscribersByCnpj(
    cnpj: string,
    pageNumber: number = 1,
    pageSize: number = 10,
    options?: {
      serviceType?: ServiceType | ServiceType[];
      status?: SubscriberStatus | SubscriberStatus[];
      operationType?: OperationType;
    }
  ): Observable<SubscribersResponse> {
    return this.getSubscribers({
      queryString: `cnpj=${cnpj}`,
      pageNumber,
      pageSize,
      ...options,
    });
  }

  getAvailableOffers(params: GetAvailableOffersParams): Observable<AvailableOffersResponse> {
    const queryString = this.buildQueryParams({
      cnpj: params.cnpj,
    });

    const url = `${this.API_URL}/available-offers?${queryString}`;
    return this.apiService.get<AvailableOffersResponse>(url);
  }
}